import React, { useState } from 'react';
import {
  ImageSourcePropType,
  ScrollView,
  StyleSheet,
  View,
} from 'react-native';
import Pill from 'shared/components/vxl/navigation/Pill/Pill';
import theme from 'shared/styles/theme';

export interface PillConfigProps {
  iconKey?: string;
  iconColor?: string;
  id: string;
  imageSource?: ImageSourcePropType;
  labelText: string;
  testID?: string;
}
export interface PillGroupProps {
  pillConfigs: PillConfigProps[];
  onSelection: (config) => void;
  initialSelectedPillId?: string;
}

const PillGroup = ({
  pillConfigs,
  onSelection,
  initialSelectedPillId,
}: PillGroupProps) => {
  const [selectedId, setSelectedId] = useState(initialSelectedPillId);

  const onPillPress = (config: PillConfigProps) => {
    setSelectedId(config?.id);
    onSelection(config);
  };

  return (
    <View style={styles.wrapper}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.scrollViewContent}
      >
        <View style={styles.container}>
          {pillConfigs.map((config) => {
            return (
              <View key={config?.id}>
                <Pill
                  isSelected={selectedId === config?.id}
                  labelText={config?.labelText}
                  iconKey={config?.iconKey}
                  iconColor={config?.iconColor}
                  imageSource={config?.imageSource}
                  onPress={() => {
                    onPillPress(config);
                  }}
                  testID={config?.testID}
                />
              </View>
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: theme.spacing.s,
    paddingVertical: theme.spacing.s,
    width: '100%',
  },
  scrollViewContent: {
    backgroundColor: theme.color.background.primary,
    flexGrow: 1,
    paddingHorizontal: theme.spacing.m,
  },
  wrapper: {
    width: '100%',
  },
});

export default PillGroup;
